export const DURATION_VALUES = [{
    title: "Last 24 hours",
    value: 1
}, {
    title: "Last week",
    value: 7
}, {
    title: "Last month",
    value: 30
}]